import React from 'react';

export default function HolidayCard2022() {
  return (
    <iframe src="https://www.liamkreiss.me/html/2022-holiday-card.html" width="100%" height="100%" title='2022 holiday card'></iframe>
  );
}
